module.exports = __webpack_public_path__ + "static/img/pailogo.dd203012.png";